var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-products-provider',{staticClass:"g-h-full",attrs:{"is-additional-order":_vm.isAdditionalOrder},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var step = ref.step;
    var patchStep = ref.patchStep;
    var goNextStep = ref.goNextStep;
    var goPreviousStep = ref.goPreviousStep;
    var isLoading = ref.isLoading;
    var isCompletingBrief = ref.isCompletingBrief;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
return [(brief)?_c('activation-brief-products-view',{attrs:{"brief":brief,"step":step,"is-loading":isLoading,"is-completing-brief":isCompletingBrief,"is-additional-order":_vm.isAdditionalOrder,"errors":errors,"error-message":errorMessage},on:{"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchStep}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }